var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "yxtbiz-audit-workflow-detail",
    },
    [
      _vm.detailInfo
        ? _c("div", { staticClass: "detail-flow" }, [
            _c(
              "div",
              { staticClass: "detail-flow-detail" },
              [
                _c("div", { staticClass: "flow-start flow-item" }, [
                  _vm._m(0),
                  _c("div", { staticClass: "right ml23" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "title mb12 color-gray-10 font-weight-400 font-size-16",
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("pc_audit_lbl_review").d("发起审核")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "userinfo font-size-14 lh20 color-gray-9",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "userinfo-icon" },
                          [
                            _c("yxtf-portrait", {
                              staticClass: "img",
                              attrs: {
                                size: "small",
                                username: _vm.detailInfo.userName,
                                imgUrl: _vm.detailInfo.pic,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "userinfo-name ml8 ell" },
                          [
                            _c("yxtbiz-user-name", {
                              attrs: { name: _vm.detailInfo.initUser },
                            }),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "userinfo-status ml24" }, [
                          _vm._v(
                            _vm._s(_vm.$t("pc_audit_lbl_initiate").d("发起"))
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "userinfo-punctuation ml5 mr5" },
                          [_vm._v(".")]
                        ),
                        _c("div", { staticClass: "userinfo-time" }, [
                          _vm._v(_vm._s(_vm.detailInfo.initTime)),
                        ]),
                      ]
                    ),
                  ]),
                ]),
                _vm._l(_vm.detailInfo.nodeJson, function (item) {
                  return _c(
                    "div",
                    { key: item.id, staticClass: "flow-pass flow-item" },
                    [
                      _c("div", { staticClass: "left" }, [
                        _c("div", { staticClass: "icon" }, [
                          _c("img", {
                            attrs: { src: _vm.getImgUrl(item.auditStatus) },
                          }),
                        ]),
                        _c("div", {
                          staticClass: "mt2 mb2",
                          class:
                            item.auditStatus == 0 || item.auditStatus === 5
                              ? "no-pass-line"
                              : "pass-line",
                        }),
                      ]),
                      _c(
                        "div",
                        { staticClass: "right ml23 mb16" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "title mb8 color-gray-10 font-weight-400 font-size-16",
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("pc_audit_lbl_audit").d("审核")
                                    )
                                ),
                              ]),
                              item.taskDetail && item.taskDetail.length > 1
                                ? [
                                    item.auditType === 1
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "need-all-pass bg-gray-2 pl8 pr8 font-size-12 color-gray-9 ml7",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("pc_audit_all_pass")
                                                  .d("需所有人通过")
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    item.auditType === 0
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "need-all-pass bg-gray-2 pl8 pr8 font-size-12 color-gray-9 ml7",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("pc_audit_one_pass")
                                                  .d("1人通过即可")
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                          item.auditStatus !== 5
                            ? _c(
                                "div",
                                {
                                  staticClass: "mb16",
                                  class: _vm.getStatusClass(item.auditStatus),
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.getItemStatus(item.auditStatus)
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._l(item.taskDetail, function (innerItem) {
                            return _c(
                              "div",
                              {
                                key: innerItem.auditTime,
                                staticClass:
                                  "userinfo font-size-14 lh20 color-gray-9 mb15",
                              },
                              [
                                innerItem.auditUser
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "userinfo-icon" },
                                        [
                                          _c("yxtf-portrait", {
                                            staticClass: "img",
                                            attrs: {
                                              size: "small",
                                              username: innerItem.userName,
                                              imgUrl: innerItem.pic,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "userinfo-name ml8 ell",
                                        },
                                        [
                                          _c(
                                            "span",
                                            [
                                              _c("yxtbiz-user-name", {
                                                attrs: {
                                                  name: innerItem.auditUser,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      innerItem.auditStatus !== 5
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "userinfo-status ml24",
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.getItemStatus(
                                                      innerItem.auditStatus
                                                    )
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: innerItem.auditTime,
                                              expression: "innerItem.auditTime",
                                            },
                                          ],
                                          staticClass: "ml5 mr5",
                                        },
                                        [_vm._v(".")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: innerItem.auditTime,
                                              expression: "innerItem.auditTime",
                                            },
                                          ],
                                          staticClass: "userinfo-time",
                                        },
                                        [_vm._v(_vm._s(innerItem.auditTime))]
                                      ),
                                      innerItem.auditDesc
                                        ? _c(
                                            "div",
                                            { staticClass: "userinfo-message" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "userinfo-message-title",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm
                                                        .$t(
                                                          "pc_audit_lbl_auditopinion"
                                                        )
                                                        .d("审核意见")
                                                    ) + "："
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "color-gray-9" },
                                                [
                                                  _c("EllipsisText", {
                                                    attrs: {
                                                      text: innerItem.auditDesc,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          }),
                        ],
                        2
                      ),
                    ]
                  )
                }),
                _c("div", { staticClass: "flow-end flow-item" }, [
                  _vm._m(1),
                  _c("div", { staticClass: "right ml23 flow-end-right" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "title mb12 color-gray-10 font-weight-400 font-size-16",
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("pc_audit_lbl_end").d("结束")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm.detailInfo.auditStatus !== 0
                      ? _c("div", { staticClass: "color-gray-9" }, [
                          _vm._v(_vm._s(_vm.detailInfo.updateTime)),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ],
              2
            ),
          ])
        : _c("yxt-empty", { attrs: { img: "nodata-new" } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("div", { staticClass: "icon" }, [
        _c("img", {
          attrs: {
            src: "https://stc.yxt.com/ufd/2338a3/auditCenter/pc/img/audit-start.png",
          },
        }),
      ]),
      _c("div", { staticClass: "pass-line mt2 mb2" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("div", { staticClass: "icon" }, [
        _c("img", {
          attrs: {
            src: "https://stc.yxt.com/ufd/2338a3/auditCenter/pc/img/audit-end-new.png",
          },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }